import "react-spring-bottom-sheet/dist/style.css";
import React from 'react';
import ReactDOM from 'react-dom';
import PetAdoptionApp from './component/PetAdoptionApp';
import './index.scss';

ReactDOM.render(
  <React.StrictMode>
    <PetAdoptionApp />
  </React.StrictMode>,
  document.getElementById('root')
);